/**
 * Medical Authority Citations
 * Sources from FDA, NIH, WHO, ECRI and other medical authorities
 */

export const CITATIONS = {
  // Internal citations
  usmlEvaluation: {
    source: 'Medical Chat USMLE Performance Evaluation',
    url: 'https://medical.chat-data.com/evaluate',
    date: '2024-01-15',
    external: false,
    description: '98.1% accuracy on USMLE benchmark, ranking #1 on official leaderboards',
  },

  // FDA citations
  fdaAiGuidance: {
    source: 'FDA AI/ML-Based Software as a Medical Device',
    url: 'https://www.fda.gov/medical-devices/software-medical-device-samd/artificial-intelligence-and-machine-learning-aiml-enabled-medical-devices',
    date: '2024-09-15',
    external: true,
    description: 'FDA guidance on AI/ML-based medical device software',
  },

  // ECRI citations
  ecriTopHazards2026: {
    source: 'ECRI Top 10 Health Technology Hazards 2026',
    url: 'https://www.ecri.org/top-health-technology-hazards',
    date: '2025-11-01',
    external: true,
    description: 'AI chatbot misuse identified as #1 health technology hazard for 2026',
  },

  // NIH citations
  nihMedicalAi: {
    source: 'NIH Medical AI Research',
    url: 'https://www.ncbi.nlm.nih.gov/pmc/',
    external: true,
    description: 'National Institutes of Health medical AI research publications',
  },

  // WHO citations
  whoAiEthics: {
    source: 'WHO Ethics and Governance of AI for Health',
    url: 'https://www.who.int/publications/i/item/9789240029200',
    date: '2021-06-28',
    external: true,
    description: 'World Health Organization guidance on AI ethics in healthcare',
  },

  // Medical databases
  merckManual: {
    source: 'Merck Manual Professional Version',
    url: 'https://www.merckmanuals.com/professional',
    external: true,
    description: 'Authoritative medical reference used for Medical Chat training data',
  },

  upToDate: {
    source: 'UpToDate Clinical Decision Support',
    url: 'https://www.uptodate.com',
    external: true,
    description: 'Evidence-based clinical decision support resource',
  },

  // Benchmarks
  medqaBenchmark: {
    source: 'MedQA Medical Question Answering Dataset',
    url: 'https://arxiv.org/abs/2009.13081',
    external: true,
    description: 'Medical question answering benchmark dataset',
  },

  // HIPAA
  hipaaGuidance: {
    source: 'HHS HIPAA for Professionals',
    url: 'https://www.hhs.gov/hipaa/for-professionals/index.html',
    external: true,
    description: 'Official HIPAA compliance guidance from HHS',
  },
};

/**
 * Format citation for display
 */
export function formatCitation(citationKey) {
  const citation = CITATIONS[citationKey];
  if (!citation) return null;

  return {
    text: citation.source,
    url: citation.url,
    date: citation.date,
    isExternal: citation.external,
    description: citation.description,
  };
}

/**
 * Generate citation list for blog posts
 */
export function generateCitationList(citationKeys) {
  return citationKeys
    .map((key) => formatCitation(key))
    .filter(Boolean);
}
